export default "__VITE_ASSET__BjYq210Q__"